var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C11.7167 12 11.4792 11.9042 11.2875 11.7125C11.0958 11.5208 11 11.2833 11 11V3C11 2.71667 11.0958 2.47917 11.2875 2.2875C11.4792 2.09583 11.7167 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3V11C13 11.2833 12.9042 11.5208 12.7125 11.7125C12.5208 11.9042 12.2833 12 12 12ZM12 21C10.75 21 9.57917 20.7625 8.4875 20.2875C7.39583 19.8125 6.44583 19.1708 5.6375 18.3625C4.82917 17.5542 4.1875 16.6042 3.7125 15.5125C3.2375 14.4208 3 13.25 3 12C3 10.9833 3.16667 9.99583 3.5 9.0375C3.83333 8.07917 4.31667 7.2 4.95 6.4C5.13333 6.16667 5.36667 6.05417 5.65 6.0625C5.93333 6.07083 6.18333 6.18333 6.4 6.4C6.58333 6.58333 6.66667 6.80833 6.65 7.075C6.63333 7.34167 6.54167 7.59167 6.375 7.825C5.925 8.425 5.58333 9.08333 5.35 9.8C5.11667 10.5167 5 11.25 5 12C5 13.95 5.67917 15.6042 7.0375 16.9625C8.39583 18.3208 10.05 19 12 19C13.95 19 15.6042 18.3208 16.9625 16.9625C18.3208 15.6042 19 13.95 19 12C19 11.2333 18.8875 10.4875 18.6625 9.7625C18.4375 9.0375 18.0833 8.375 17.6 7.775C17.4333 7.55833 17.3417 7.32083 17.325 7.0625C17.3083 6.80417 17.3917 6.58333 17.575 6.4C17.775 6.2 18.0167 6.09583 18.3 6.0875C18.5833 6.07917 18.8167 6.18333 19 6.4C19.65 7.2 20.1458 8.075 20.4875 9.025C20.8292 9.975 21 10.9667 21 12C21 13.25 20.7625 14.4208 20.2875 15.5125C19.8125 16.6042 19.1708 17.5542 18.3625 18.3625C17.5542 19.1708 16.6042 19.8125 15.5125 20.2875C14.4208 20.7625 13.25 21 12 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutWhite);
export default __webpack_public_path__ + "static/media/logout-white.bb2bbc9b0aec93bbd05d853757a64c1a.svg";
export { ForwardRef as ReactComponent };